import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["slide", "dot"];

  connect() {
    this.index = 0;
    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches)
      this.timer = window.setInterval(() => this.show(this.index + 1), 5000);
  }

  disconnect() {
    window.clearInterval(this.timer);
  }

  select(event) {
    this.show(Number(event.currentTarget.dataset.index));
  }

  show(index) {
    this.index = index % this.slideTargets.length;
    this.slideTargets.forEach((slide, position) => {
      const active = position === this.index;
      slide.classList.toggle("opacity-100", active);
      slide.classList.toggle("opacity-0", !active);
      slide.classList.toggle("pointer-events-none", !active);
      slide.setAttribute("aria-hidden", (!active).toString());
    });
    this.dotTargets.forEach((dot, position) => {
      const active = position === this.index;
      dot.classList.toggle("w-8", active);
      dot.classList.toggle("bg-accent", active);
      dot.classList.toggle("w-4", !active);
      dot.classList.toggle("bg-white/35", !active);
    });
  }
}
